<!--
* UI Name: Process Detail
* Modify Date: 2021.12.22
-->
<template>
  <div class="pa-4 custome-border-component fixed-height-comp">
    <!-- Header -->
    <v-row class="page-header mt-0">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold custom-title">
          {{ $t('lbl.processSetup.eventHistory') }}
        </v-toolbar-title>
      </v-col>
    </v-row>
    <!-- Condition search -->
    <v-row class="custom-form-control admin-process-style custom-figma-1 mb-0">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
            cols="12"
            lg="7"
            md="7"
          >
            <v-row>
              <v-col cols="12" lg="6" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="searchProcessName"
                  @keyup.enter="searchData"
                  :label="$t('lbl.processSetup.addProcess.applyHistory.workflowName')"
                  dense
                  filled
                  class="custom-selectbox"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="searchProcessId"
                  @keyup.enter="searchData"
                  :label="$t('lbl.processSetup.addProcess.applyHistory.workflowId')"
                  dense
                  filled
                  class="custom-selectbox"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right"
            cols="12"
            lg="5"
            md="5"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control"></div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn class="btn btn-top btn-search btn-width-1" color="primary" @click="searchData">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>
                {{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="search-detail-style">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="3" md="3">
            <span>{{ $t('lbl.admin.owner') }}</span>
            <span>{{ stateViewInfo.groupId }}</span>
          </v-col>
          <v-col lg="3" md="3">
            <span>{{ $t('lbl.admin.company') }}</span>
            <span>{{ stateViewInfo.userId }}</span>
          </v-col>
          <v-col lg="6" md="6">
            <span>{{ $t('lbl.admin.workflow') }}</span>
            <span class="pr-2" v-if="!configMess">{{ stateViewInfo.processSetupId }}</span>
            <span class="pr-2" v-else>
              <a
                class="link-file-text"
                @click="openBackupFileContentView(configMess, 'Route Information', 0)"
                >{{ stateViewInfo.processSetupId }}</a
              >
            </span>
            <v-btn :disabled="!stateViewInfo.processSetupId" class="btn btn-search pa-0 ma-0">
              <v-icon @click="openProcessWindow(stateViewInfo)" x-small>fa fa-search</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="search-detail-style">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="6" md="6"></v-col>
          <v-col lg="6" md="6">
            <span>{{ $t('lbl.admin.workflowNm') }}</span>
            <span>{{ stateViewInfo.procNm }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="pt-3">
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="itemsArray"
          :height="tableHeight"
          :fixed-header="true"
          hide-default-footer
          item-key="name"
          :class="[
            'list-table admin-process-style srm-list-table custom-border-table',
            itemsArray.length > 0 ? '' : 'custom-border-table-not-data',
          ]"
          disable-pagination
          disable-sort
        >
          <template v-slot:item.eventMessage="{ item }">
            <span class="pr-2" v-if="!item.message">{{ $t('btn.common.view') }}</span>
            <a
              @click="openBackupFileContentView(item.message, 'Event Message', item.INDEX)"
              class="link-file-text cursor-pointer layout-col"
              >{{ $t('btn.common.view') }}</a
            >
          </template>
          <template v-slot:item.timestamp="{ item }">
            <font>{{ applyGmtTimeZone(item.timestamp) }}</font>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <ErrorMessage
        v-if="dialog.type == 'errorMessageWindow'"
        :id="dialog.id"
        :title="title"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :errorMessage="dialog.item.data"
      ></ErrorMessage>
      <backupFileContentView
        v-if="dialog.type == 'backupFileContentView'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :title="title"
      ></backupFileContentView>
    </div>
    <dialogWindow
      ref="searchEventHistory"
      size="max"
      :detail="detail"
      :color="checkDialogColor"
    ></dialogWindow>
  </div>
</template>

<script>
import $ from 'jquery';
import { resizeTableHeight } from '@/vue-dlb/common/common';

import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
const moment = require('moment');

import ErrorMessage from '@/vue-caas/views/admin/ErrorMessageView.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import backupFileContentView from '@/vue-caas/views/admin/EventHistoryView.vue';
import { setProcessWindowList, deleteProcessWindow } from '@/vue-caas/utils/process';
import { openWindow } from '@/vue-dlb/utils/window-opener';

export default {
  props: {
    processSetupId: {
      default: '',
    },
  },
  components: {
    SystemProgress,
    ErrorMessage,
    dialogWindow,
    backupFileContentView,
  },

  data() {
    return {
      dialogs: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialog: false,
      title: '',
      stateViewInfo: {
        groupId: '',
        userId: '',
        processSetupId: '',
      },
      headers: [
        {
          text: 'Function',
          align: 'start',
          sortable: false,
          value: 'type',
          width: '25%',
        },
        { text: 'State', value: 'state', width: '25%' },
        {
          text: 'Event Message',
          value: 'eventMessage',
          align: 'center',
          width: '25%',
        },
        { text: 'Date & Time', value: 'timestamp', width: '25%' },
      ],
      listData: [],
      itemsArray: [],
      isCreated: false,
      tableHeight: '',
      isLoading: false,
      searchProcessName: '',
      searchProcessId: '',
      checkDialogColor: 'warning',
      checkDialogTitle: '',
      configMess: '',
      detail: '',
    };
  },

  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  watch: {
    processSetupId() {
      this.searchProcessId = this.processSetupId;
      this.searchData();
    },
  },

  created() {
    this.isCreated = true;
  },

  methods: {
    openBackupFileContentView(outputFileContent, title, time) {
      let type = 'backupFileContentView';
      this.title = title;
      let item = {
        ROWID: 0,
        id: time.toString(),
        fileContent: outputFileContent,
      };
      let indexArrDialog = this.findDialog('backupFileContentView_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    applyGmtTimeZone(date) {
      let newM = '';
      if (date !== undefined && date !== '') {
        newM = moment
          .utc(date)
          .add(this.$cookies.get('gmt-timezone'), 'hours')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      return newM;
    },
    searchData() {
      if (!this.searchProcessName && !this.searchProcessId) {
        this.$refs.searchEventHistory.dialog = true;
        this.detail = this.$t('lbl.admin.search_event_history_validation');
      } else {
        this.isLoading = true;
        const param = {
          name: this.searchProcessName,
          id: this.searchProcessId,
          ownerId: this.$cookies.get('ownr-id'),
        };

        this.$store
          .dispatch('checkProcessSetupEvent', param)
          .then((res) => {
            if (!res || !res.verNo) {
              this.isLoading = false;
              this.stateViewInfo = {
                groupId: '',
                userId: '',
                processSetupId: '',
                procId: '',
                procNm: '',
                versionNo: '',
              };
              this.configMess = '';
              this.itemsArray = [];
              return;
            }
            this.stateViewInfo = {
              groupId: res.compId,
              userId: res.prnrId,
              processSetupId: res.procId + '-' + res.verNo,
              procId: res.procId,
              procNm: res.procNm,
              versionNo: res.verNo,
            };

            const params = {
              searchProcessId: this.stateViewInfo.processSetupId,
            };

            this.$store
              .dispatch('getEventHistoryList', params)
              .then(() => {
                this.listData = this.$store.getters.eventHistoryData;
                if (this.listData.eventHistory && this.listData.eventHistory.length > 0) {
                  this.itemsArray = this.listData.eventHistory[0].history;
                } else {
                  this.itemsArray = [];
                }
                this.itemsArray.map((e, i) => (e.INDEX = i + 1));

                let config = this.listData.routeConfigs[0].routes;
                let mess = [];
                for (let i = 0; i < config.length; i++) {
                  mess.push(JSON.parse(config[i].config));
                }
                this.configMess = JSON.stringify(mess);
                this.isLoading = false;
              })
              .catch((ex) => {
                this.isLoading = false;
              });
          })
          .catch((ex) => {
            this.isLoading = false;
          });
      }
    },
    openProcessWindow(item) {
      const isHistory = true;
      const type = 'History';
      const params = {
        ROWID: item.procId.toString(),
        type: type,
        options: {
          dataValue: item.procId,
          id: item.procId.toString(),
          isHistory: isHistory,
          versionNo: (item.versionNo / 10).toString(),
          fromTransaction: true,
        },
      };
      item.id = item.procId;
      const arrView = {
        item,
        type,
      };
      const url = `/process/workflowDetailNew/${type}/${params.ROWID}/${params.options.versionNo}`;
      const size = 'width=1800,height=950,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    openErrorMessageWindow(message, title) {
      this.title = title;
      let type = 'errorMessageWindow';
      let item = {
        ROWID: 0,
        data: message,
      };
      let indexArrDialog = this.findDialog('errorMessageWindow_0');
      if (indexArrDialog != null) {
        indexArrDialog;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, item, options };
    },
    selectDialog(obj) {
      console.log(obj);
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 165 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 165 + 'px';
    });
  },
};
</script>

<style scoped>
.user-dialog {
  width: 1100px !important;
}
</style>
